export default __webpack_public_path__ + "static/sentrydefault_1280x720-cdc523040868659765758096559adcbb.webp";